module.exports = __webpack_public_path__ + "img/personal_details_border.6dcdecb6.svg";